module.exports = __webpack_public_path__ + "ag.no1.32a7d65e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ag.no1.jpg
// module id = UC8m
// module chunks = 0